import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const LotUpdateViewDialogTourConfig: AgTechTourConfig = {
    id: 'lot-update-view-dialog-tour',
    name: 'Update Lots Tour',
    steps: [
        {
            targetId: 'lot-update-grid',
            title: 'Editing Lots',
            description: 'Every lot in the sale is listed in sale order. Edit lot numbers, descriptions, categories and other details directly in the grid. Use the toolbar to export or manage lots.',
            position: 'top',
        },
    ]
}
